export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900 p-8 md:p-12">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-accent-400 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-primary-400 blur-3xl"></div>
          </div>
          <div className="relative flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-4">
                移动端体验
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
                随时随地 · 掌上私密视频
              </h2>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-lg mb-6">
                私密视频完美适配移动端浏览器，无需下载安装即可享受流畅观影。
                支持红桃视频、西瓜视频免费、小蓝视频、茄子视频、久久视频、芒果视频全平台内容，
                高清画质不缓冲，通勤路上、午休间隙，碎片时间也能沉浸在精彩视频世界中。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-smartphone-line text-lg"></i>
                  手机端立即体验
                </a>
                <a
                  href="#features"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 text-background-50 border border-background-50/20 rounded-full font-medium text-sm hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-computer-line text-lg"></i>
                  查看平台特性
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-56 h-96 md:w-64 md:h-[420px] rounded-2xl overflow-hidden border-4 border-background-50/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20video%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20movie%20posters%20grid%2C%20cinematic%20UI%20design%2C%20minimalist%20modern%20layout%2C%20entertainment%20platform%20app%2C%20clean%20mobile%20interface%2C%20no%20text%20legible%2C%20abstract%20design&width=560&height=900&seq=app-mockup&orientation=portrait"
                  alt="私密视频移动端界面"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}